<template>
  <div :class="{ 'active-tab-underline': isCurrentActiveTab, 'tab-item': true }">
    <button class="tab-title" @click="routeToView()" @keydown="handleEscape" :aria-label="'Account Navigation'">
      {{ tab.title }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TabMenuItem",
  props: {
    tab: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(["currentActiveTabId", "accountInfo", "pendingPaperlessChanges"]),
    isCurrentActiveTab() {
      return this.currentActiveTabId === this.tab.tabId;
    }
  },
  methods: {
    ...mapActions([
      "setCurrentActiveTabId",
      "logout",
      "setShowLogoutModal",
      "setShowUnsavedChangesModal",
      "setNextRoute"
    ]),
    routeToView() {
      this.$store.dispatch("createNewTimer");
      this.setCurrentActiveTabId(this.tab.tabId);
      if (this.tab.tabId === 4) {
        // Logout tab
        // Trigger logout modal to confirm
        this.setShowLogoutModal(true);
      }
      else {
        // TODO: two ifs with the same code??? Pls consider revising after release time
        if (this.$route.name === "Payment" || this.$route.name === "confirmation") {
          // we are in the payment flow
          this.setNextRoute(this.tab.route);
          this.setShowUnsavedChangesModal(true);
        }
        else if (this.$route.name === "Statements" && this.pendingPaperlessChanges) {
          // We are navigating from statements page w/ unsaved paperless changes
          this.setNextRoute(this.tab.route);
          this.setShowUnsavedChangesModal(true);
        }
        else {
          this.$router.push({
            name: this.tab.route,
            params: this.tab.params
          });
        }
      }
      this.$emit("closeMobileMenu");
    },
    handleEscape(e) {
      if (e.key === "Escape") {
        this.$emit("closeMobileMenu");
      }
    }
  },
  mounted() {
    this.tab.params = this.accountInfo;
  }
};
</script>

<style lang="scss" scoped>
.tab-item:hover {
  cursor: pointer;
}

.tab-title {
  all: unset;
  font-family: "Poppins";
  font-weight: 500;
  font-size: 16px;
  line-height: 26.24px;
  text-align: center;
  padding: 15px;
  white-space: nowrap;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
}

.tab-title:focus-visible {
  outline: 2px solid black;
}

.active-tab-underline {
  border-bottom: 5px;
  background: linear-gradient(to left, #4fa800 2.31%, #006747 99.65%) left bottom #ffffff no-repeat;
  background-size: 100% 5px;

  @media (max-width: 1100px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    background: linear-gradient(117.73deg, #007aa3 0%, #004e69 100%);
    border-radius: 10px;
    color: rgba(255, 255, 255, 1);
  }
}

.hamburger-tab>button {
  border-radius: 10px;
}
</style>
